import styled from 'styled-components'
import { device } from 'src/theme/theme'

export const Content = styled.div`
  padding: 0 0 3.75rem;

  p {
    margin: 0 0 1rem;
  }

  .text-container + .text-container {
    margin: 1rem 0;
    @media ${device.tablet} {
      margin: 1rem 0 0;
    }
  }

  .text-container {
    display: flex;
    p {
      margin: 0;
      ${({ theme }) => ({ ...theme.size.xs })}
      @media ${device.mobileM} {
        ${({ theme }) => ({ ...theme.size.sm })}
      };
      @media ${device.laptop} {
        ${({ theme }) => ({ ...theme.size.md })}
      }
    }
    a {
      ${({ theme }) => ({ ...theme.size.xs })}
      margin-left: 0.2rem;
      color: ${({ theme }) => theme.colors.palette.secondary600};
      @media ${device.mobileM} {
        ${({ theme }) => ({ ...theme.size.sm })}
      }
      @media ${device.laptop} {
        ${({ theme }) => ({ ...theme.size.md })}
      }
    }
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: 'form' 'advertising';
  margin-top: ${p => p.theme.spacing.extraLarge};
  gap: 1rem 0;

  @media ${device.tablet} {
    gap: 1.5rem;
    grid-template-columns: 65%;
    grid-template-areas: 'form advertising';
  }
`

export const FormContainer = styled.div`
  grid-area: form;
  .form-content {
    padding: 1rem 1rem 2rem;
    border-radius: 0.5rem;
    background: ${({ theme }) => theme.colors.palette.neutral300};
  }
`

export const BannerContainer = styled.div`
  grid-area: advertising;
`
